import React from 'react';
import { createSelector } from 'reselect';
import { connect } from 'react-redux';
import { contains } from 'ramda';

import { getMetric, getPrecision } from '../../selectors/options';
import {
  getLocations,
  getSortedSelectedWithDataIds,
  getLocationsWithMultipleDataIds,
} from '../../selectors/locations';
import { getCrimes } from '../../selectors/crimes';
import { MetricProp } from '../../constants';
import { legendColors } from '../../theme';
import LineChart from './LineChart';
import ChartAndLegend from '../ChartAndLegend';

export const getLegendData = createSelector(
  getLocations,
  getLocationsWithMultipleDataIds,
  getSortedSelectedWithDataIds,
  (cities, multipleIds, sortedIds) =>
    sortedIds.filter(id => contains(id, multipleIds)).map((id, i) => ({
      id,
      name: cities.find(city => city.id === id).name,
      color: legendColors[i % legendColors.length],
    })),
);

export const getChartData = createSelector(
  getLocations,
  getCrimes,
  getLocationsWithMultipleDataIds,
  getSortedSelectedWithDataIds,
  getMetric,
  (cities, crimes, multipleIds, sortedIds, metric) =>
    sortedIds.filter(id => contains(id, multipleIds)).map((id, i) => {
      const color = legendColors[i % legendColors.length];
      const city = cities.find(city => city.id === id);

      return {
        id,
        name: city.name,
        color,
        points: crimes[id].map(item => ({
          x: new Date(item.timespan.split('/')[0]).getTime(),
          y: item[MetricProp[metric]],
          color,
          name: city.name,
          state: city.state,
        })),
      };
    }),
);

export default connect(state => ({
  chartData: getChartData(state),
  legendData: getLegendData(state),
  precision: getPrecision(state),
}))(props => (
  <ChartAndLegend chartComponent={LineChart} resetSelectionOnClick {...props} />
));



// WEBPACK FOOTER //
// ./src/components/LineChart/LineChartContainer.jsx